var physics = require('ngraph.physics.primitives');

module.exports = function(pos) {
  return new physics.Body(pos);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ngraph.physics.simulator/lib/createBody.js
// module id = 616
// module chunks = 0